import BossModel from "@/models/BossModel";

export default class Type extends BossModel {

    static apiUrl = 'product/allowance/type';

    static entity = 'productAllowanceTypes';

    static fields() {
        return {
            id: this.number(null).nullable(),
            name: this.attr(null),
            code: this.attr(null),
            is_active: this.boolean(true),
        }
    }
}
